export default {
  label: 'Applica la commissione di servizio agli ordini al tavolo',
  description: 'Gli ordini al tavolo non pagano la commissione di servizio se questa opzione non è attiva.',
  no_fee: 'Il tuo ristorante non applica costi di servizio, quindi nemmeno gli ordini al tavolo ne pagano.',
  partner_default_on: 'Predefinito del partner: attivo',
  partner_default_off: 'Predefinito del partner: disattivo',
  toasts: {
    on: 'Ora gli ordini al tavolo pagano la commissione di servizio',
    off: 'Ora gli ordini al tavolo non pagano la commissione di servizio',
    error: 'Salvataggio non riuscito. Riprova.',
  },
};
